import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_ISSUE_LINKED } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDIssueLinkedState extends EntityState<IID_ISSUE_LINKED, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_ISSUE_LINKED })
@InterfaceDataStore(InterfaceName.ISSUE_LINKED)
export class IIDIssueLinkedStore extends EntityStore<IIDIssueLinkedState> {
  constructor() {
    super([]);
  }
}
